<div class="secret-value-dialog">
  <div mat-dialog-title class="dialog-header">
    <h2>Secret Value</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="secret-info">
      <h3>{{ data.secret.name }}</h3>
      <p class="secret-meta">Source: {{ getSourceName() }} • {{ data.secret.gettable ? 'Gettable' : 'Write-only' }}</p>
    </div>

    @if (loading()) {
      <div class="loading-container">
        <mat-spinner diameter="32"></mat-spinner>
        <p>Retrieving secret value...</p>
      </div>
    }

    @if (error()) {
      <div class="error-container">
        <mat-icon>error</mat-icon>
        <p>{{ error() }}</p>
      </div>
    }

    @if (secretValue() && !loading()) {
      <div class="value-container">
        <mat-form-field appearance="outline" class="value-field">
          <mat-label>Secret Value</mat-label>
          <input
            matInput
            [type]="hideValue ? 'password' : 'text'"
            [value]="secretValue()"
            readonly
            class="secret-value-input"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="toggleValueVisibility()"
            [attr.aria-label]="hideValue ? 'Show value' : 'Hide value'"
          >
            <mat-icon>{{ hideValue ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>

        <button
          mat-button
          (click)="copyToClipboard()"
          class="copy-button"
          [disabled]="copySuccess()"
        >
          <mat-icon>{{ copySuccess() ? 'check' : 'content_copy' }}</mat-icon>
          <span>{{ copySuccess() ? 'Copied!' : 'Copy' }}</span>
        </button>
      </div>
    }
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onClose()">Close</button>
  </div>
</div>
